"use client";

import { useIsSemDiscoverPage } from "@faire/retailer-visitor-shared/lib/useIsSemDiscoverPage";
import { useSettingIsPerfAppSemDiscoverTreatment } from "@faire/retailer-visitor-shared/settings/useSettingPerfAppSemDiscover";

type Props = {
  children: React.ReactNode;
};

export const HideOnSemDiscoverPageTreatment: React.FC<Props> = ({
  children,
}) => {
  const isSemDiscoverPage = useSettingIsPerfAppSemDiscoverTreatment();
  return isSemDiscoverPage ? null : children;
};

export const ShowOnSemDiscoverPageTreatment: React.FC<Props> = ({
  children,
}) => {
  const isSemDiscoverPage = useSettingIsPerfAppSemDiscoverTreatment();
  return isSemDiscoverPage ? children : null;
};

export const HideOnSemDiscoverPage: React.FC<Props> = ({ children }) => {
  const isSemDiscoverPage = useIsSemDiscoverPage();
  return isSemDiscoverPage ? null : children;
};
